// Global premium navigation — the exact Season Table / Weekly Cup BACK and
// HOME buttons (same classes, same production webp art) for other screens.
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HOME_PATH } from '@/components/RankedChrome';

const ART = '/kickard/season-table';
const VARS = {
  '--kst-btn-back': `url(${ART}/btn_back.webp)`,
  '--kst-btn-home': `url(${ART}/btn_home.webp)`,
};

export function PremiumBackButton({ onClick, testid = 'nav-back', label = 'Back' }) {
  return <button type="button" onClick={onClick} className="kst__back" style={VARS} data-testid={testid} aria-label={label} />;
}

export function PremiumHomeButton({ onClick, testid = 'nav-home' }) {
  const navigate = useNavigate();
  return (
    <button type="button" onClick={onClick || (() => navigate(HOME_PATH))} className="kst__home" style={VARS}
      data-testid={testid} aria-label="Home" />
  );
}

/** Back via history when there is an in-app origin; Home when opened directly. */
export function useSafeBack() {
  const navigate = useNavigate();
  const location = useLocation();
  return () => (location.key === 'default' ? navigate(HOME_PATH) : navigate(-1));
}

/** BACK top-left · centre slot · HOME top-right, on one row. */
export function PremiumNavRow({ onBack, backTestId, homeTestId, onHome, children, className = '' }) {
  return (
    <div className={`kpn-row ${className}`}>
      <PremiumBackButton onClick={onBack} testid={backTestId} />
      <div className="kpn-center">{children}</div>
      <PremiumHomeButton onClick={onHome} testid={homeTestId} />
    </div>
  );
}
